"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./MobileMenu.scss");
var _generateLinks = _interopRequireDefault(require("../../utils/generateLinks"));
var _rightCaretLightGray = _interopRequireDefault(require("../../images/right-caret-light-gray.svg"));
var _formatID = _interopRequireDefault(require("../../utils/formatID"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _useFocus = require("../../utils/hooks/useFocus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MobileMenu = _ref => {
  let {
    links,
    text,
    toggleDropDown,
    isOpen,
    closeDropDown,
    Link,
    currentOpenMenu,
    hamburgerIsOpen,
    contentfulId
  } = _ref;
  const {
    mouse
  } = _useMouse.default;
  const [collapsedMenu, setCollapsedMenu] = (0, _useFocus.useFocus)();
  const [uncollapsedMenu, setUncollapsedMenu] = (0, _useFocus.useFocus)();
  const generateMenuLinks = () => {
    return (0, _generateLinks.default)(links, "ter-mobile-menu__link", closeDropDown, text, mouse, Link, 2);
  };
  const toggleWithEnter = (e, id, direction) => {
    if (e.keyCode === 13) {
      toggleDropDown(id);
      if (direction === "open") {
        setCollapsedMenu();
      } else {
        setUncollapsedMenu();
      }
    }
  };
  const invisible = currentOpenMenu !== null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu ${isOpen ? "ter-mobile-mega-menu--reveal" : "ter-mobile-mega-menu--reveal--from-right"}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    // id={formatID(`${contentfulId}-mini-menu-name`)}
    className: `ter-mobile-mega-menu__name ${isOpen ? "ter-mobile-mega-menu__name--open" : ""} ${mouse ? "" : "tabFocus"}`,
    tabIndex: mouse ? "" : "0",
    onClick: () => toggleDropDown(contentfulId),
    onKeyDown: e => toggleWithEnter(e, contentfulId, "open"),
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    ref: uncollapsedMenu,
    "data-depth": 1
  }, text, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-menu__caret ${isOpen ? "ter-mobile-menu__caret--up" : "ter-mobile-menu__caret--down"}`,
    src: _rightCaretLightGray.default,
    alt: "caret icon"
  })), /*#__PURE__*/_react.default.createElement("ul", {
    className: `ter-mobile-menu__link-container ter-mobile-menu__link-container--is-open`
  }, generateMenuLinks())), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu ${invisible ? "ter-mobile-mega-menu--inactive" : ""}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    // id={formatID(`${contentfulId}-mini-menu-name`)}
    className: `ter-mobile-mega-menu__name ${currentOpenMenu || !hamburgerIsOpen ? "" : "ter-mobile-mega-menu__name--open-parent"} ${mouse ? "" : "tabFocus"}`,
    onClick: () => toggleDropDown(contentfulId),
    onKeyDown: e => toggleWithEnter(e, contentfulId, "close"),
    tabIndex: mouse ? "" : "0",
    "aria-haspopup": "menu",
    "aria-expanded": !isOpen,
    ref: collapsedMenu,
    "data-depth": 1
  }, text, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-menu__caret ${isOpen ? "ter-mobile-menu__caret--up" : "ter-mobile-menu__caret--down"}`,
    src: _rightCaretLightGray.default,
    alt: "caret icon"
  }))));
};
var _default = MobileMenu;
exports.default = _default;